export enum InlineAlertTypes {
	info,
	warning,
	error,
	success,
	alarm
}